(function () {
  "use strict";

  if (window.__snapReserveLandingLoaded) return;
  window.__snapReserveLandingLoaded = true;

  function initSnapReserve(root) {
    if (!root || root.dataset.srReady === "true") return;
    root.dataset.srReady = "true";
    var cleanup = [];

    function listen(target, eventName, callback, options) {
      if (!target) return;
      target.addEventListener(eventName, callback, options);
      cleanup.push(function () { target.removeEventListener(eventName, callback, options); });
    }

    var galleryImage = root.querySelector("[data-sr-gallery-main]");
    var galleryButtons = Array.prototype.slice.call(root.querySelectorAll("[data-sr-gallery-thumb]"));
    galleryButtons.forEach(function (button) {
      listen(button, "click", function () {
        if (!galleryImage) return;
        if (button.dataset.srcset) {
          galleryImage.srcset = button.dataset.srcset;
        } else {
          galleryImage.removeAttribute("srcset");
        }
        galleryImage.src = button.dataset.src || galleryImage.src;
        galleryImage.alt = button.dataset.alt || "";
        galleryButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", active ? "true" : "false");
        });
      });
    });

    // These element-local listeners remain attached to their original elements.
    // Retain them on a same-node editor reload without registering duplicates.
    if (root.dataset.srCompatibilityTabsReady !== "true") {
    var compatibilityTabs = Array.prototype.slice.call(
      root.querySelectorAll("[data-sr-compatibility-tab]")
    );
    var compatibilityPanels = Array.prototype.slice.call(
      root.querySelectorAll("[data-sr-compatibility-panel]")
    );

    function activateCompatibility(tab, focusTab) {
      var targetId = tab.getAttribute("aria-controls");
      compatibilityTabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
        item.tabIndex = active ? 0 : -1;
      });
      compatibilityPanels.forEach(function (panel) {
        panel.hidden = panel.id !== targetId;
      });
      if (focusTab) tab.focus();
    }

    compatibilityTabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activateCompatibility(tab, false);
      });
      tab.addEventListener("keydown", function (event) {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === "ArrowLeft") nextIndex = (index - 1 + compatibilityTabs.length) % compatibilityTabs.length;
        if (event.key === "ArrowRight") nextIndex = (index + 1) % compatibilityTabs.length;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = compatibilityTabs.length - 1;
        activateCompatibility(compatibilityTabs[nextIndex], true);
      });
    });

      root.dataset.srCompatibilityTabsReady = "true";
    }

    var form = root.querySelector("[data-sr-product-form], form.sr-product-form");
    var phoneModel = root.querySelector("[data-sr-phone-model]");
    var secondPhoneWrap = root.querySelector("[data-sr-second-phone-wrap]");
    var secondPhoneModel = root.querySelector("[data-sr-second-phone-model]");
    var returnTo = root.querySelector("[data-sr-return-to]");
    var variantSelect = root.querySelector("[data-sr-variant-select]");
    var variantInput = root.querySelector("[data-sr-variant-input]");
    var submitIdField = root.querySelector("[data-sr-submit-id]");
    var quantityInputs = Array.prototype.slice.call(root.querySelectorAll("[data-sr-quantity]"));
    var submitButtons = root.querySelectorAll("[data-sr-submit]");
    var stockNote = root.querySelector(".sr-stock-note");
    var giftInput = root.querySelector("[data-sr-gift-input]");
    var modelToggle = root.querySelector("[data-sr-model-toggle]");
    var modelSummary = root.querySelector("[data-sr-model-summary]");
    var pairChosen = false;

    // The phone model fields sit in a collapsed row so the button stays close
    // to the offers. The row opens and shows the model once one is entered.
    function updateModelSummary() {
      if (!modelSummary) return;
      var value = phoneModel ? phoneModel.value.trim() : "";
      modelSummary.textContent = value
        ? "Phone model: " + value
        : (pairChosen ? "Add your phone models" : "Add your phone model");
    }
    var pricingElement = root.querySelector("[data-sr-pricing]");
    var pricing = null;
    try {
      pricing = pricingElement ? JSON.parse(pricingElement.textContent) : null;
    } catch (error) {
      // Keep the native product form usable if an editor preview has incomplete data.
    }
    var bundleVariantId = pricing && pricing.bundleVariantId ? String(pricing.bundleVariantId) : "";

    function isAvailable(value) {
      return value === true || value === "true";
    }

    function currentPricing() {
      var variantId = variantSelect ? variantSelect.value : (variantInput && variantInput.value);
      if (!pricing) return null;
      var variants = Array.isArray(pricing.variants) ? pricing.variants : [];
      var selected = variants.find(function (variant) { return String(variant.id) === String(variantId); });
      if (selected) return selected;
      return String(pricing.variantId) === String(variantId) ? pricing : null;
    }

    function setText(selector, value, hide) {
      root.querySelectorAll(selector).forEach(function (target) {
        if (value !== undefined && value !== null) target.textContent = String(value);
        if (hide !== undefined) target.hidden = hide;
      });
    }

    function updateOfferLabels(name, offer) {
      if (!offer) return;
      var hasSaving = Number(offer.saving) > 0;
      setText("[data-sr-offer-" + name + "-price]", offer.price);
      setText("[data-sr-offer-" + name + "-compare]", offer.compare || "", !offer.compare || !hasSaving);
      setText("[data-sr-offer-" + name + "-save]", "SAVE " + (offer.save || ""), !hasSaving);
      if (name === "pair") setText("[data-sr-offer-pair-each]", offer.each);
    }

    function updateStock(available) {
      if (!stockNote) return;
      var option = variantSelect && variantSelect.options[variantSelect.selectedIndex];
      var message = available ? "Free nationwide delivery" : "Sold out";
      if (available && option && option.dataset.inventoryManaged === "true") {
        var count = Number(option.dataset.inventoryQuantity);
        if (count > 0 && count < 10) message = "Only " + count + (count === 1 ? " unit left!" : " units left!");
      } else if (available && !option) {
        // Preserve the server-rendered inventory count for a single-variant product.
        return;
      }
      stockNote.textContent = "";
      var dot = document.createElement("span");
      dot.setAttribute("aria-hidden", "true");
      dot.textContent = "●";
      stockNote.appendChild(dot);
      stockNote.appendChild(document.createTextNode(" " + message));
    }

    function updateSelection() {
      var selected = currentPricing();
      var option = variantSelect && variantSelect.options[variantSelect.selectedIndex];
      var available = selected ? isAvailable(selected.available) : isAvailable(option ? option.dataset.available : root.dataset.srVariantAvailable);
      var pairAvailable = available && !!selected && isAvailable(selected.pairAvailable);
      var singleRadio = quantityInputs.find(function (input) { return input.value === "1"; });
      var pairRadio = quantityInputs.find(function (input) { return input.value === "2"; });

      quantityInputs.forEach(function (input) {
        input.disabled = input.value === "2" ? !pairAvailable : !available;
      });
      if (pairRadio && pairRadio.checked && !pairAvailable) {
        pairRadio.checked = false;
        if (singleRadio) singleRadio.checked = true;
      }
      if (!quantityInputs.some(function (input) { return input.checked; }) && singleRadio) singleRadio.checked = true;
      var pairSelected = !!(pairRadio && pairRadio.checked && pairAvailable);

      if (submitIdField) {
        var singleId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : "");
        submitIdField.value = (pairSelected && bundleVariantId) ? bundleVariantId : singleId;
      }

      var offer = selected && (pairSelected ? selected.pair : selected.single);

      if (offer) {
        var hasSaving = Number(offer.saving) > 0;
        setText("[data-sr-price]", offer.price);
        setText("[data-sr-compare]", offer.compare || "", !offer.compare || !hasSaving);
        var percent = Number(offer.percent) || 0;
        setText("[data-sr-save]", percent > 0 ? percent + "% OFF" : "SAVE " + (offer.save || ""), !hasSaving);
      }
      if (selected) {
        updateOfferLabels("single", selected.single);
        updateOfferLabels("pair", selected.pair);
        if (selected.pair) {
          setText("[data-sr-pair-price]", selected.pair.price);
          setText("[data-sr-pair-each]", selected.pair.each);
        }
      }
      if (giftInput) giftInput.value = pairSelected ? "2 x Magnetic ring" : "Magnetic ring";
      pairChosen = pairSelected;
      updateModelSummary();
      if (secondPhoneWrap) secondPhoneWrap.hidden = !pairSelected;
      if (secondPhoneModel) secondPhoneModel.disabled = !pairSelected;
      submitButtons.forEach(function (button) { button.disabled = !available; });
      root.querySelectorAll("[data-sr-button-available]").forEach(function (label) { label.hidden = !available; });
      root.querySelectorAll("[data-sr-button-sold-out]").forEach(function (label) { label.hidden = available; });
      updateStock(available);
      queueStickyUpdate();
    }

    function updateVariant() {
      if (variantSelect && variantInput) variantInput.value = variantSelect.value;
      updateSelection();
    }

    quantityInputs.forEach(function (input) { listen(input, "change", updateSelection); });
    listen(variantSelect, "change", updateVariant);
    root.querySelectorAll("[data-sr-select-pair]").forEach(function (link) {
      listen(link, "click", function () {
        var pairRadio = quantityInputs.find(function (input) { return input.value === "2"; });
        if (pairRadio && !pairRadio.disabled) {
          pairRadio.checked = true;
          updateSelection();
        }
      });
    });

    if (phoneModel) {
      // The phone model field is shown as required (label badge, pill) but
      // must never block add-to-cart: it stays optional at the form level.
      listen(phoneModel, "input", function () {
        phoneModel.setCustomValidity("");
        if (modelToggle && phoneModel.value.trim() && !modelToggle.open) modelToggle.open = true;
        updateModelSummary();
      });
      listen(phoneModel, "change", updateModelSummary);
    }

    var cartError = root.querySelector("[data-sr-cart-error]");
    var cartCounts = root.querySelectorAll("[data-sr-cart-count]");
    var addingToCart = false;

    function storeRoot() {
      var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return (base || "/").replace(/\/?$/, "/");
    }

    function drawerElement() {
      return document.querySelector("theme-drawer#cart-drawer");
    }

    function setBusy(busy) {
      submitButtons.forEach(function (button) {
        button.classList.toggle("is-loading", busy);
        button.setAttribute("aria-busy", busy ? "true" : "false");
        if (busy) button.disabled = true;
      });
      if (!busy) updateSelection();
    }

    function showCartError(message) {
      if (!cartError) return;
      cartError.classList.remove("is-success");
      cartError.textContent = message || "";
      cartError.hidden = !message;
    }

    function updateCartCount(count) {
      cartCounts.forEach(function (badge) {
        badge.textContent = String(count);
        badge.hidden = !count;
      });
    }

    function fetchCart() {
      return fetch(storeRoot() + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (response) { return response.json(); });
    }

    function withTimeout(promise, ms) {
      return new Promise(function (resolve) {
        var done = false;
        var timer = window.setTimeout(function () { if (!done) { done = true; resolve(null); } }, ms);
        Promise.resolve(promise).then(function (value) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          resolve(value);
        }, function () {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          resolve(null);
        });
      });
    }

    // Shopify's standard cart event lets the theme refresh the cart drawer.
    // If that module can't load, an equivalent plain event is used instead.
    function loadEvents() {
      var loader;
      try {
        loader = import("@shopify/events");
      } catch (error) {
        loader = Promise.resolve(null);
      }
      return withTimeout(loader, 2500).then(function (mod) {
        return mod && mod.CartLinesUpdateEvent ? mod.CartLinesUpdateEvent : null;
      });
    }

    function createDeferred(LinesEvent) {
      if (LinesEvent && typeof LinesEvent.createPromise === "function") {
        try { return LinesEvent.createPromise(); } catch (error) { /* use plain promise */ }
      }
      var deferred = {};
      deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      return deferred;
    }

    function createLinesEvent(LinesEvent, payload) {
      if (LinesEvent) {
        try { return new LinesEvent(payload); } catch (error) { /* use plain event */ }
      }
      var event = new Event("shopify:cart:lines-update", { bubbles: true, composed: true });
      Object.keys(payload).forEach(function (key) {
        try { Object.defineProperty(event, key, { value: payload[key] }); } catch (error) { /* ignore */ }
      });
      return event;
    }

    function cartSummary(LinesEvent, cart) {
      if (LinesEvent && typeof LinesEvent.createCartFromAjaxResponse === "function") {
        try { return LinesEvent.createCartFromAjaxResponse(cart); } catch (error) { /* use plain summary */ }
      }
      return {
        id: cart.token,
        totalQuantity: cart.item_count,
        cost: { totalAmount: { amount: String((cart.total_price || 0) / 100), currencyCode: cart.currency } },
        lines: []
      };
    }

    // Replaces the drawer contents directly when the theme did not refresh them.
    function refreshDrawerContents(sectionHtml) {
      var drawer = drawerElement();
      if (!drawer || !sectionHtml || !window.DOMParser) return;
      var current = drawer.querySelector(".cart-drawer__inner");
      if (!current || !current.classList.contains("cart-drawer--empty")) return;
      var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
      var fresh = parsed.querySelector(".cart-drawer__inner");
      if (!fresh) return;
      current.className = fresh.className;
      current.innerHTML = fresh.innerHTML;
    }

    function openDrawer() {
      if (!drawerElement()) return Promise.resolve(false);
      var defined = window.customElements && window.customElements.whenDefined
        ? window.customElements.whenDefined("theme-drawer")
        : Promise.resolve();
      return withTimeout(defined, 4000).then(function () {
        var drawer = drawerElement();
        if (!drawer || typeof drawer.open !== "function") return false;
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            try {
              if (!drawer.isOpen) drawer.open();
              resolve(true);
            } catch (error) {
              resolve(false);
            }
          }, 80);
        });
      });
    }

    function showAddedFallback() {
      if (!cartError) return;
      cartError.hidden = false;
      cartError.classList.add("is-success");
      cartError.textContent = "";
      cartError.appendChild(document.createTextNode("Added to your cart. "));
      var checkout = document.createElement("a");
      checkout.href = storeRoot() + "checkout";
      checkout.textContent = "Go to checkout";
      cartError.appendChild(checkout);
    }

    // Adds to cart in the background and slides out the theme's cart drawer.
    function addToDrawer() {
      var formData = new FormData(form);
      formData.delete("return_to");
      var sectionIds = ["cart-drawer-section"];
      document.querySelectorAll("cart-items-component").forEach(function (item) {
        var id = item.dataset && item.dataset.sectionId;
        if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
      });
      formData.append("sections", sectionIds.join(","));
      formData.append("sections_url", window.location.pathname);
      var itemCount = Number(formData.get("quantity")) || 1;
      var merchandiseId = String(formData.get("id"));

      return loadEvents().then(function (LinesEvent) {
        return fetch(storeRoot() + "cart/add.js", {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
        }).then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && !data.status, data: data };
          }, function () {
            return { ok: response.ok, data: {} };
          });
        }).then(function (result) {
          if (!result.ok) {
            showCartError(result.data.description || result.data.message || "Sorry, we couldn't add that to your cart. Please try again.");
            return;
          }
          showCartError("");
          var sections = result.data.sections || {};
          var deferred = createDeferred(LinesEvent);
          form.dispatchEvent(createLinesEvent(LinesEvent, {
            action: "add",
            context: "product",
            lines: [{ merchandiseId: merchandiseId, quantity: itemCount }],
            promise: deferred.promise
          }));

          var drawerOpened = openDrawer();
          return fetchCart().then(function (cart) {
            updateCartCount(cart.item_count);
            deferred.resolve({
              cart: cartSummary(LinesEvent, cart),
              detail: {
                items: cart.items,
                source: "snapreserve-landing",
                sourceId: root.dataset.sectionId || "",
                itemCount: itemCount,
                productId: "",
                sections: sections,
                didError: false
              }
            });
          }, function () {
            deferred.resolve({
              cart: { id: "", totalQuantity: itemCount, cost: { totalAmount: { amount: "0", currencyCode: "" } }, lines: [] },
              detail: { items: [], source: "snapreserve-landing", sourceId: "", itemCount: itemCount, productId: "", sections: sections, didError: false }
            });
          }).then(function () {
            return drawerOpened;
          }).then(function (opened) {
            window.setTimeout(function () { refreshDrawerContents(sections["cart-drawer-section"]); }, 600);
            if (!opened) showAddedFallback();
          });
        });
      });
    }

    listen(form, "submit", function (event) {
      if (phoneModel) phoneModel.value = phoneModel.value.trim();
      if (secondPhoneModel && !secondPhoneModel.disabled) secondPhoneModel.value = secondPhoneModel.value.trim();
      if (returnTo) {
        var incoming = new URLSearchParams(window.location.search);
        var outgoing = new URL(storeRoot() + "cart", window.location.origin);
        incoming.forEach(function (value, key) {
          if (value && (/^utm_/i.test(key) || key === "fbclid")) outgoing.searchParams.set(key, value);
        });
        returnTo.value = outgoing.pathname + outgoing.search;
      }

      // Without fetch the browser falls back to Shopify's normal cart page.
      if (!window.fetch || !window.FormData || !window.Promise) return;
      event.preventDefault();
      if (addingToCart) return;
      addingToCart = true;
      showCartError("");
      setBusy(true);
      addToDrawer().catch(function () {
        showCartError("Sorry, something went wrong. Please try again.");
      }).then(function () {
        addingToCart = false;
        setBusy(false);
      });
    });

    root.querySelectorAll("[data-sr-open-cart]").forEach(function (link) {
      listen(link, "click", function (event) {
        var drawer = drawerElement();
        if (!drawer || typeof drawer.open !== "function") return;
        event.preventDefault();
        drawer.open();
      });
    });

    var stickyBar = root.querySelector(".sr-mobile-sticky");
    var stickyButton = root.querySelector(".sr-sticky-button");
    var primaryButton = root.querySelector(".sr-primary-button[data-sr-submit]");
    var stickyFrame = null;

    function updateSticky() {
      stickyFrame = null;
      if (!stickyBar || !primaryButton) return;
      var shouldShow = window.matchMedia("(max-width: 640px)").matches && primaryButton.getBoundingClientRect().bottom <= 0;
      stickyBar.classList.toggle("is-visible", shouldShow);
      stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
      if (stickyButton) stickyButton.tabIndex = shouldShow ? 0 : -1;
    }

    function queueStickyUpdate() {
      if (!stickyBar || !primaryButton || stickyFrame !== null) return;
      stickyFrame = window.requestAnimationFrame(updateSticky);
    }

    if (stickyBar && primaryButton) {
      updateSticky();
      listen(window, "scroll", queueStickyUpdate, { passive: true });
      listen(window, "resize", queueStickyUpdate);
    }
    updateVariant();

    root.__srCleanup = function () {
      cleanup.forEach(function (removeListener) { removeListener(); });
      if (stickyFrame !== null) window.cancelAnimationFrame(stickyFrame);
      if (stickyBar) {
        stickyBar.classList.remove("is-visible");
        stickyBar.setAttribute("aria-hidden", "true");
      }
      if (stickyButton) stickyButton.tabIndex = -1;
      delete root.dataset.srReady;
      delete root.__srCleanup;
    };
  }

  function eachRoot(scope, callback) {
    var base = scope || document;
    if (base.matches && base.matches("[data-sr-section]")) callback(base);
    base.querySelectorAll("[data-sr-section]").forEach(callback);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { eachRoot(document, initSnapReserve); }, { once: true });
  } else {
    eachRoot(document, initSnapReserve);
  }
  document.addEventListener("shopify:section:load", function (event) { eachRoot(event.target, initSnapReserve); });
  document.addEventListener("shopify:section:unload", function (event) {
    eachRoot(event.target, function (root) { if (root.__srCleanup) root.__srCleanup(); });
  });
})();
